module.exports = __webpack_public_path__ + "img/userAva.7267900f.png";